"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _Button = _interopRequireDefault(require("../Button"));
var _IconBellOutline = _interopRequireDefault(require("../../icons/General/IconBellOutline"));
var _IconBellFilled = _interopRequireDefault(require("../../icons/General/IconBellFilled"));
var _Text = _interopRequireDefault(require("../Text"));
var _react2 = require("motion/react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NotificationsMenu = ({
  unreadCount,
  triggerClose,
  radius,
  children,
  animationActive = false,
  onBellClick
}) => {
  const ref = /*#__PURE__*/(0, _react.createRef)();
  const [open, setOpen] = (0, _react.useState)(false);
  const hasUnread = Boolean(unreadCount);
  const maxUnreadCount = 99;
  (0, _react.useEffect)(() => {
    const handleClickOutside = e => {
      const node = ref.current;
      if (node && node.contains(e.target)) {
        return;
      }
      setTimeout(() => {
        setOpen(false);
      }, 100);
    };
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open, ref]);
  (0, _react.useEffect)(() => {
    if (triggerClose) setOpen(false);
  }, [triggerClose]);
  const onClick = () => {
    setOpen(!open);
    onBellClick && onBellClick();
  };
  const variant = {
    initial: {
      rotate: [0, 10, 0],
      transition: {
        duration: 0.2,
        repeat: Infinity
      }
    },
    none: {}
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.NotificationsWrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.motion.div, {
      animate: animationActive ? 'initial' : 'none',
      variants: variant,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.default, {
        nostyle: true,
        onClick: onClick,
        focusable: true,
        "aria-expanded": open,
        "aria-label": hasUnread ? 'Uleste notifikasjoner' : 'Ingen uleste notifikasjoner',
        trackingName: "Felles",
        trackingEvent: "Toggle varselmeny",
        children: [hasUnread ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconBellOutline.default, {
          secondary: true
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconBellFilled.default, {}), hasUnread && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.UnreadMark, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            size: "12px",
            color: "white",
            children: unreadCount <= maxUnreadCount ? unreadCount : maxUnreadCount
          })
        })]
      })
    }), open && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      ref: ref,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.NotificationsContent, {
        $radius: radius,
        children: children
      })
    })]
  });
};
var _default = exports.default = NotificationsMenu;